<template>
  <div class="card">
    <div class="delivery">
      <div class="delivery-list" v-for="(item, index) in orderList" :key="index" >
      <van-row class="info-line">
        <van-col :span="12"><span>交货单号：</span><span>{{item.deliveryCode}}</span></van-col>
        <van-col :span="12"><span>订单号：</span><span>{{item.orderCode}}</span></van-col>
      </van-row>
      <van-row class="info-line">
        <van-col :span="16"><span>产品名称：</span><span>{{item.commodityName}}</span></van-col>
        <van-col :span="8"><span>牌号：</span><span>{{item.spec}}</span></van-col>    
      </van-row>
      <van-row class="info-line">
        <van-col :span="24"><span>卖家名称：</span><span>{{item.sellerName}}</span></van-col>    
      </van-row>
      
      </div>
     
    </div>
  </div>
</template>
<script>
// import orderApi from "@/request/orderApi";
export default {
  name: "QualificationCard",
  props: {
    orderList: Array,
  },
  data() {
    return {
     
    };
  },
  computed: {
    
  
  },
  methods: {
    toDetails() {
      // this.$router.push("/qualificationDetails");
    }
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';
.font30 {
  font-size: 30px;
}
.delivery-list >>> .van-col {
    line-height: 50px;
}
.card {
  margin-top: 24px;
  font-size: 26px;
  .delivery {
    margin-top: 50px;
  }
  .delivery-list {
      background: #fff; 
      padding: 20px;
      margin-top: 10px;
      // margin:10px 10px 0 10px;
      border-radius: 6px;
      .info-line-status {
        font-size: 26px;
        font-weight: 600;
      }
  }

  .color-red {
    color: #E12020;
  }
  .card-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 120px;

    .btn {
      min-width: 200px;
      height: 72px;
      background: $gradientColor;
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
  }
}
</style>